import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PATHS_LOGIN_PAGES } from '../commons/config/path-pages';
import { KEYS_WEB_STORAGE } from '../commons/util/emun';
import { IDataUser } from '../commons/models/data-user';
import { customBlankSpacesValidator } from '../validations/form-validations';
import { Router } from '@angular/router';
import { SessionStorageService } from '../commons/services/local/storage/storage.service';
import { AuthService } from '../commons/services/local/auth-services';
import { DataUserService } from '../commons/services/local/data-user.service';
import { UserService } from '../user/user.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent implements OnInit {

  formGroup!: FormGroup;
  public isInvalidCurrentPassword = false;
  public isInvalidNewPassword = false;
  public isInvalidConfirmNewPassword = false;
  disableButton = false;
  public errorMessage: string;
  style = 'material';
  errores: string[] = [];
  userId: number;
  userCurrentPassword: string;
  showPassword: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    private _router: Router,
    private _dataUserService: DataUserService,
    private _userService: UserService,
    private _sessionsStorageService: SessionStorageService,
    private _authService: AuthService) {
    this._loadFormGroup();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  ngOnInit(): void {
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.pushState(null, '', location.href);
      this._logOutAndRedirect();
    };

    this.userId = this._dataUserService.getId() as number;

    this._userService.getPassword(this.userId).subscribe(
      (response) => {
        if (response.success && response.result) {
          this.userCurrentPassword = response.result;
        }
      },
      (error) => {
        console.error('Error obteniendo la contraseña:', error);
      }
    );
  }

  private _logOutAndRedirect(): void {
    this._sessionsStorageService.clear();
    this._authService.logout();
    this._router.navigateByUrl('/login');
  }

  private _loadFormGroup(): void {
    this.formGroup = this._formBuilder.group(
      {
        currentPassword: [null, [customBlankSpacesValidator, Validators.required]],
        newPassword: [null, [customBlankSpacesValidator, Validators.required]],
        confirmNewPassword: [null, [customBlankSpacesValidator, Validators.required]]
      }
    );
  }

  clickChangePassword(): void {
    if (this.formGroup.valid) {
      this.disableButton = true;
      const userId = this.userId;
      const newPassword = this.newPasswordField.value
      const confirmNewPassword = this.confirmNewPasswordField.value

      if (this.userCurrentPassword === this.currentPasswordField.value) {
        if (newPassword === confirmNewPassword) {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false,
            allowOutsideClick: false,
            showCloseButton: false
          })

          this._userService.updatePassword(userId, newPassword).subscribe({
            next: (response) => {
              swalWithBootstrapButtons.fire({
                title: '',
                text: 'Clave cambiada correctamente.',
                icon: 'success',
                confirmButtonText: 'OK',
              }).then((result) => {
                if (result.isConfirmed) {
                  swalWithBootstrapButtons.close();
                  this.updateStateInSession();
                  void this._router.navigateByUrl(PATHS_LOGIN_PAGES.loginPage.withSlash);
                }
              });
            },
            error: (error) => {
              swalWithBootstrapButtons.close();
              for (let i = 0; i < error.error.errorList.length; i++) {
                this.errores.push(error.error.errorList[i].message);
              }
              this.disableButton = false;
              this.errorMessage = error.error.errorList[0].message;
              this.isInvalidNewPassword = true;
              this.isInvalidConfirmNewPassword = true;
              this.isInvalidCurrentPassword = false;
            }
          })
        }
        else {
          this.disableButton = false;
          this.errorMessage = "La confirmación de la contraseña nueva no coincide.";
          this.isInvalidCurrentPassword = false;
          this.isInvalidNewPassword = false;
          this.isInvalidConfirmNewPassword = true;
        }
      }
      else {
        this.disableButton = false;
        this.errorMessage = "La contraseña actual es incorrecta.";
        this.isInvalidCurrentPassword = true;
        this.isInvalidNewPassword = false;
        this.isInvalidConfirmNewPassword = false;
      }
    } else {
      if (this.currentPasswordField.value == null) {
        this.isInvalidCurrentPassword = true;
      } else {
        this.isInvalidCurrentPassword = false;
      }
      if (this.newPasswordField.value == null) {
        this.isInvalidNewPassword = true;
      }
      else {
        this.isInvalidCurrentPassword = false;
      }
      if (this.confirmNewPasswordField.value == null) {
        this.isInvalidConfirmNewPassword = true;
      }
      else {
        this.isInvalidConfirmNewPassword = false;
      }
    }
  }

  updateStateInSession() {
    const dataUser = this._sessionsStorageService.getItem<IDataUser>(KEYS_WEB_STORAGE.DATA_USER);
    dataUser.changePassword = false;
    this._sessionsStorageService.setItem(KEYS_WEB_STORAGE.DATA_USER, dataUser);

  }

  onCurrentPasswordInput() {
    if (this.currentPasswordField?.value) {
      this.isInvalidCurrentPassword = false;
    }
  }

  onNewPasswordInput() {
    if (this.newPasswordField?.value) {
      this.isInvalidNewPassword = false;
    }
  }

  onConfirmNewPasswordInput() {
    if (this.confirmNewPasswordField?.value) {
      this.isInvalidConfirmNewPassword = false;
    }
  }

  get currentPasswordField(): AbstractControl {
    return this.formGroup.get('currentPassword')!;
  }
  get newPasswordField(): AbstractControl {
    return this.formGroup.get('newPassword')!;
  }
  get confirmNewPasswordField(): AbstractControl {
    return this.formGroup.get('confirmNewPassword')!;
  }

}
